<template>
    <v-row>
        <v-col cols="12" md="12" sm="12" class="d-flex justify-end">
            <v-text-field v-model="search" append-icon="fas fa-search"
            label="Buscar empleado" single-inline hide-details>
            </v-text-field>
        </v-col>
        <v-col cols="12">
            <v-simple-table fixed-header height="auto" dense class="elevation-4">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left primary white--text font-weight-bold">Empleado</th>
                            <th class="text-left primary white--text font-weight-bold">Datos</th>
                            <th class="text-left primary white--text font-weight-bold">Bonos</th>
                            <th class="text-left primary white--text font-weight-bold">Comentarios</th>
                            <th class="text-left primary white--text font-weight-bold">Pago neto</th>
                            <th class="text-left primary white--text font-weight-bold">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item) in filterEmployees" :key="item.idEmpleado">
                            <td>
                                <v-autocomplete class="mt-2" :items="[item]" item-text="nombreCompleto" item-value="idEmpleado"
                                filled outlined required solid disabled dense prepend-inner-icon="fas fa-user-alt"
                                :value="item.idEmpleado">
                                </v-autocomplete>
                            </td>

                            <td>
                                <p class="font-weight-bold">
                                    Dias laborados: {{ item.diasTrabajadosEstaSemana }}<br/>
                                    Salario al dia: <span class="green--text font-weight-bold">$ </span>{{ item.salarioDia }}
                                </p>
                            </td>

                            <td>
                                <v-text-field :value="item.bonos" v-model="item.bonos" type="number" solo
                                class="font-weight-bold text-h8 mt-2 green--text"
                                prepend-inner-icon="fas fa-dollar-sign"
                                persistent-hint min="0">
                                </v-text-field>
                            </td>

                            <td>
                                <v-text-field :value="item.comentarios" v-model="item.comentarios" type="text" solo
                                class="font-weight-bold text-h8 mt-2 green--text"
                                persistent-hint>
                                </v-text-field>
                            </td>

                            <td>
                                <p class="text-h6">
                                    <span class="green--text">$ </span>{{ getNetSalary(item) }}
                                </p>
                            </td>

                            <td>
                                <v-row align="center" justify="center" class="mb-1">
                                    <span class="group pa-1">
                                        <v-icon dense class="mx-1 pa-1" left color="red darken-3"
                                        @click.prevent="deleteEmployee(item)">fas fa-trash-alt
                                        </v-icon>
                                    </span>
                                </v-row>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "AddEmployeeDetail",
        props: {
            employees: { type: Array, default: () => [] },
            addDetails: { type: Function }
        },
        created() {
            this.detailRayaEmployee = this.employees;
        },
        data() {
            return {
                detailRayaEmployee: [],
                search: ''
            }
        },
        methods: {
            // Method for calculate net salary
            getNetSalary(item) {
                if (!item || typeof item.salarioDia !== 'number' || typeof item.diasTrabajadosEstaSemana !== 'number') {
                    return 0;
                }

                const salarioBase = item.salarioDia * item.diasTrabajadosEstaSemana;
                const bonos = Number(item.bonos) || 0;
                const total = salarioBase + bonos;
                return parseFloat(total).toFixed(2);
            },
            removeEmployee(item){
                const index = this.detailRayaEmployee.findIndex(detail => detail.idEmpleado === item.idEmpleado);
                if (index !== -1) {
                    this.detailRayaEmployee.splice(index, 1);
                }
            },
            deleteEmployee(item) {
                this.$swal.fire({
                    title: "Eliminar de la lista de raya",
                    text: `¿Estas seguro de eliminar a ${ item.nombreCompleto } de la lista de raya?, No se podra revertir la decision!`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, eliminar!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        const itemIndex = this.detailRayaEmployee.findIndex(detail => detail === item);
        
                        if (itemIndex !== -1) {
                            this.detailRayaEmployee.splice(itemIndex, 1);
                        }
                    }
                });
            },

            // Method for emit data to father
            emitData(data){
                this.$emit('addDetails', data);
            },
        },
        watch: {
            detailRayaEmployee: {
                handler(newValue) {
                    this.emitData(newValue);
                },
                deep: true
            },
        },
        computed: {
            filterEmployees() {
                return this.detailRayaEmployee.filter(item => item.nombreCompleto.toLowerCase().includes(this.search.toLowerCase()));
            }
        }
    }
</script>